import { useCallback, useState, useEffect } from 'react'
import {
  ApiErrorResponse,
  getKyousouApiClient,
  handleError,
} from '../services/network'
import { useSnackBar } from '../providers/snack_bar_provider'
import { BusinessIdeaUserEvaluationType } from '../enums/BusinessIdeaUserEvaluation'

/**
 * 事業アイデアユーザー評価機能のカスタムフック
 */
export const useBusinessIdeaUserEvaluation = (
  businessIdeaId: string,
  initialEvaluation?: BusinessIdeaUserEvaluationType | null
) => {
  const apiClient = getKyousouApiClient()
  const { showSnackBar } = useSnackBar()
  const [currentEvaluation, setCurrentEvaluation] =
    useState<BusinessIdeaUserEvaluationType | null>(initialEvaluation ?? null)
  const [isEvaluating, setIsEvaluating] = useState(false)

  useEffect(() => {
    setCurrentEvaluation(initialEvaluation ?? null)
  }, [initialEvaluation])

  /**
   * 事業アイデアを評価する
   */
  const evaluate = useCallback(
    async (evaluation: BusinessIdeaUserEvaluationType) => {
      // 同じ評価を再度送信しない
      if (isEvaluating || currentEvaluation === evaluation) {
        return
      }

      setIsEvaluating(true)

      try {
        await apiClient.business.evaluationCreate(businessIdeaId, {
          evaluation,
        })
        setCurrentEvaluation(evaluation)
      } catch (error) {
        console.error('評価の更新に失敗しました:', error)
        handleError(error as ApiErrorResponse, showSnackBar)
      } finally {
        setIsEvaluating(false)
      }
    },
    [businessIdeaId, currentEvaluation, isEvaluating, apiClient, showSnackBar]
  )

  return {
    currentEvaluation,
    isEvaluating,
    evaluate,
  }
}
